import { render, staticRenderFns } from "./ProMateriaLibrary.vue?vue&type=template&id=09491b46"
import script from "./ProMateriaLibrary.vue?vue&type=script&lang=js"
export * from "./ProMateriaLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports